// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 962 ? "QQShare" : chunkId) + "." + {"388":"b7c87010f8","962":"2cb209b1a2"}[chunkId] + ".js";
};